import { render, staticRenderFns } from "./taxation-project-form.vue?vue&type=template&id=c1e30150&"
import script from "./taxation-project-form.vue?vue&type=script&lang=js&"
export * from "./taxation-project-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports